<div>
  <h1>BAC GP Support Table</h1>
  <div class="tablebox">
    <table class="table mb-0">
      <tr>
        <th>BC Number</th>
        <th>BC Name</th>
        <th>Total Bill GP</th>
        <th>Total Open GP (backlog)</th>
        <th>Current Support %</th>
        <th>Name of Support</th>
      </tr>
      <tr>
        <td>1007</td>
        <td>Dennis Cruz</td>
        <td>$345,340.00</td>
        <td>$145,540.00</td>
        <td>70%</td>
        <td>BAS</td>
      </tr>
      <tr>
        <td>10009</td>
        <td>Alyson Oliveri</td>
        <td>$985,600.00</td>
        <td>$742,320.00</td>
        <td>20%</td>
        <td>BAS</td>
      </tr>
    </table>
  </div>
</div>
